export default __webpack_public_path__ + "static/media/45_walk_his_way.956768e6.png";